import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const useShift = () => {
  const [loading, setLoading] = useState({
    btn: false,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addShift = async data => {
    setLoading({ btn: data.id });
    await dispatch({
      local_storage: {
        key: "basket",
        value: { ...data, step: 1 },
      },
      type: "SET",
      payload: { basket: { ...data, step: 1 } },
    });
    // console.log(data); 
    navigate("/card");
    setTimeout(() => {
      setLoading({ btn: false });
    }, 1500);
  };
  const renderBtn = data => {
    let result = {
      text: " رزرو شیفت",
      style: {
        backgroundColor: "#34a853",
        borderColor: "#309c4d",
        width: "100px",
      },
    };
    // basket.map(item => {
    //   if (item.shift_id == data.id) {
    //     result = {
    //       text: "در حال رزرو",
    //       style: {
    //         backgroundColor: "#e42a3f",
    //         borderColor: "#309c4d",
    //         width: "100px",
    //       },
    //     };
    //   }
    // });
    return result;
  };
  return {
    loading,
    addShift,
    renderBtn,
  };
};
